module.exports = __webpack_public_path__ + "static/media/stayhome.60de0ba5.svg";